module.exports = __webpack_public_path__ + "img/more.0a23f6c6.webp";